import {
  Button,
  DatePicker,
  Divider,
  Drawer,
  Input,
  InputNumber,
  Select,
  Space,
  Tag,
  Typography,
  message,
} from 'antd';
import CustomSelect from '../../common/Select/Select';
import { useContext, useMemo, useState } from 'react';
import { initFilters } from './Transactions';
import { CountryContext } from '../../common/Navigation/Navigation';
import { yearOptions } from '../Invoices/Invoices';

const { Option } = Select;

const transactionDateOptions = [
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    label: 'This month',
    value: 'This month',
  },
  {
    label: 'Last month',
    value: 'Last month',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

export default function FiltersPane({
  openFilters,
  setOpenFilters,
  filterValues,
  setFilterValues,
  handleApply,
}) {
  const { Text } = Typography;
  const { countries } = useContext(CountryContext);
  const [payOpen, setPayOpen] = useState(false);
  const [amountOpen, setAmountOpen] = useState(false);

  const productivityCategories = useMemo(() =>
    [
      'System-Tracked Hours',
      'System-Tracked Units',
      'Self-Reported Hours',
      'Self-Reported Units',
    ].map((category) => ({
      key: category,
      value: category,
    })),
  );

  const getTansactionCategoryFilters = useMemo(() => {
    console.log('filterValues', filterValues);

    const adjustmentCategories = ['Correction', 'Appen China', 'Bonus'].map(
      (category) => ({ key: category, value: category }),
    );

    if (filterValues['transactionType'] === 'Productivity') {
      return [
        { key: 'All', value: '', label: 'All' },
        ...productivityCategories,
      ];
    } else if (filterValues['transactionType'] === 'Adjustment') {
      return [{ key: 'All', value: '', label: 'All' }, ...adjustmentCategories];
    } else {
      return [
        { key: 'All', value: '', label: 'All' },
        ...productivityCategories,
        ...adjustmentCategories,
      ];
    }
  }, [filterValues]);

  const getPayRateOptions = [
    { key: 'All', value: '', label: 'All' },
    { key: '$0', value: '0 - 0', label: '$0' },
    { key: '$0.01 - $5', value: '0.01 - 5', label: '$0.01 - $5' },
    { key: '$6 - $10', value: '6 - 10', label: '$6 - $10' },
    { key: '$11 - $15', value: '11 - 15', label: '$11 - $15' },
    { key: '$16 - $20', value: '16 - 20', label: '$16 - $20' },
    { key: '$21 - $25', value: '21 - 25', label: '$21 - $25' },
    { key: '$26 - $30', value: '26 - 30', label: '$26 - $30' },
    { key: '$31 - $35', value: '31 - 35', label: '$31 - $35' },
    { key: '$36 - $40', value: '36 - 40', label: '$36 - $40' },
    { key: '$41 - $45', value: '41 - 45', label: '$41 - $45' },
    { key: '$46 - $50', value: '46 - 50', label: '$46 - $50' },
    { key: '$51 or above', value: '51', label: '$51 or above' },
  ];

  const getAmountOptions = [
    { key: 'All', value: '', label: 'All' },
    { key: '$-0.01 and below', value: '-0.01', label: '$-0.01 and below' },
    { key: '$0 - $25', value: '0 - 25', label: '$0 - $25' },
    { key: '$26 - $50', value: '26 - 50', label: '$26 - $50' },
    { key: '$51 - $100', value: '51 - 100', label: '$51 - $100' },
    { key: '$101 - $200', value: '101 - 200', label: '$101 - $200' },
    { key: '$201 - $300', value: '201 - 300', label: '$201 - $300' },
    { key: '$301 - $400', value: '301 - 400', label: '$301 - $400' },
    { key: '$401 - $500', value: '401 - 500', label: '$401 - $500' },
    { key: '$501 or above', value: '501', label: '$501 or above' },
  ];

  const transactionStatusOptions = [
    {
      key: 'Ready for Finance Review',
      value: 'Ready for Finance Review',
    },
    {
      key: 'Ready for Invoice',
      value: 'Ready for Invoice',
    },
    {
      key: 'Under Further Review',
      value: 'Under Further Review',
    },
    {
      key: 'Voided',
      value: 'Voided',
    },
    {
      key: 'Rejected',
      value: 'Rejected',
    },
    {
      key: 'Added to Invoice',
      value: 'Added to Invoice',
    },
    {
      key: 'Added to Payout',
      value: 'Added to Payout',
    },
    {
      key: 'Payout Pending',
      value: 'Payout Pending',
    },
    {
      key: 'Payout Failure',
      value: 'Payout Failure',
    },
    {
      key: 'Payout Completed',
      value: 'Payout Completed',
    },
  ];

  const preventBackspaceDelete = (e) => {
    if (e.key === 'Backspace') {
      e.stopPropagation();
    }
  };

  const handleAmount = (_type, key) => {
    const [min, setMin] = useState();
    const [max, setMax] = useState();
    const [error, setError] = useState();
    const handleCustomGo = () => {
      if (
        min === null ||
        min === undefined ||
        max === null ||
        max === undefined
      ) {
        setError(`Amount should n't be empty`);
      } else if (min > max) {
        setError(`Min amount should be less then max amount`);
      } else if (filterValues['payRate'].includes(`${min}-${max}`)) {
        setError(`Amount alredy selected`);
      } else {
        handleFilterChange(`$${min} - $${max}`, _type, key);
        setError(null);
        setMin(undefined);
        setMax(undefined);
        if (key === 'payRate') {
          setPayOpen(false);
        } else {
          setAmountOpen(false);
        }
      }
    };
    return (
      <>
        <div style={{ display: 'flex', alignItems: 'center', padding: 8 }}>
          <InputNumber
            placeholder="$"
            style={{ width: 80 }}
            value={min}
            onKeyDown={preventBackspaceDelete}
            onChange={(e) => {
              setMin(e), error && setError(null);
            }}
          />
          <span style={{ margin: '0 8px' }}>to</span>
          <InputNumber
            placeholder="$"
            style={{ width: 80 }}
            value={max}
            onKeyDown={preventBackspaceDelete}
            onChange={(e) => {
              setMax(e), error && setError(null);
            }}
          />
          <Button
            type="primary"
            style={{ marginLeft: 8 }}
            onClick={() => handleCustomGo()}
          >
            GO
          </Button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: 8 }}>
          {error && <Tag color="red">{error}</Tag>}
        </div>
      </>
    );
  };

  // List of filters
  const filters = [
    {
      name: 'Contributor',
      key: 'contributorEmail',
      // type: 'select',
      type: 'text',
      mode: 'multiple',
      value: filterValues['contributorEmail'] || '',
      disabled: true,
    },
    {
      name: 'Contributor Project ID',
      key: 'contributorProjectId',
      // type: 'select',
      type: 'text',
      mode: 'multiple',
      value: '',
    },
    {
      name: 'Contributor Country',
      key: 'country',
      mode: 'multiple',
      type: 'select',
      options: countries,
    },
    {
      name: 'Project Name',
      key: 'project',
      // type: 'select',
      type: 'text',
      mode: 'multiple',
    },
    {
      name: 'Transaction Type',
      key: 'transactionType',
      type: 'select',
      defaultValue: '',
      options: [
        {
          key: 'All',
          value: '',
          label: 'All',
        },
        {
          key: 'Productivity',
          value: 'Productivity',
        },
        {
          key: 'Adjustment',
          value: 'Adjustment',
        },
      ],
    },
    {
      name: 'Transaction Category',
      key: 'category',
      type: 'custom',
      defaultValue: '',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            defaultValue={''}
            value={filterValues['category'] || ''}
            mode="multiple"
            options={getTansactionCategoryFilters}
            placeholder="Select..."
            onChange={(e) => handleFilterChange(e, 'select', 'category')}
          />
        </div>
      ),
    },
    {
      name: 'Transaction date',
      key: 'transactionDate',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) => handleFilterChange(e, 'select', 'transactionDate')}
            options={transactionDateOptions}
            value={filterValues['transactionDate'] || ''}
            defaultValue={filterValues['transactionDate'] || ''}
          />
          {filterValues.transactionDate === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={filterValues['transactionDate.customDates']}
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'transactionDate.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Transaction ID',
      key: 'transactionId',
      // type: 'select',
      type: 'text',
      mode: 'multiple',
    },
    {
      name: 'Invoice Period',
      key: 'invoicePeriod',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            value={filterValues['invoicePeriod.month']}
            mode="multiple"
            placeholder="Enter month"
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoicePeriod.month')
            }
            options={[
              { key: 'January', value: 'January' },
              { Key: 'February', value: 'February' },
              { key: 'March', value: 'March' },
              { key: 'April', value: 'April' },
              { key: 'May', value: 'May' },
              { key: 'June', value: 'June' },
              { key: 'July', value: 'July' },
              { key: 'August', value: 'August' },
              { key: 'September', value: 'September' },
              { key: 'October', value: 'October' },
              { key: 'November', value: 'November' },
              { key: 'December', value: 'December' },
            ]}
          />
          <Select
            style={{ flex: 1 }}
            value={filterValues['invoicePeriod.year']}
            placeholder="Enter Year"
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoicePeriod.year')
            }
            options={yearOptions || []}
          />
        </div>
      ),
    },
    {
      name: 'Pay Rate',
      key: 'payRate',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) => {
              handleFilterChange(e, 'select', 'payRate');
            }}
            placeholder={'Pay Rate'}
            open={payOpen}
            onDropdownVisibleChange={(visible) => setPayOpen(visible)}
            value={filterValues['payRate'] || []}
            defaultValue={filterValues['payRate'] || []}
            dropdownRender={(menu) => (
              <>
                {menu}
                {handleAmount('select', 'payRate')}
              </>
            )}
          >
            {getPayRateOptions.map(({ key, label, value }) => (
              <Option key={key} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </div>
      ),
    },
    {
      name: 'Transaction Amount',
      key: 'amount',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) => {
              handleFilterChange(e, 'select', 'amount');
            }}
            placeholder={'Transaction Amount'}
            open={amountOpen}
            onDropdownVisibleChange={(visible) => setAmountOpen(visible)}
            value={filterValues['amount'] || []}
            defaultValue={filterValues['amount'] || []}
            dropdownRender={(menu) => (
              <>
                {menu}
                {handleAmount('select', 'amount')}
              </>
            )}
          >
            {getAmountOptions.map(({ key, label, value }) => (
              <Option key={key} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </div>
      ),
    },
    {
      name: 'Transaction Status',
      key: 'transactionStatus',
      mode: 'multiple',
      type: 'select',
      options: transactionStatusOptions,
    },
    {
      name: 'Created Date',
      key: 'createdDate',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) => handleFilterChange(e, 'select', 'createdDate')}
            options={transactionDateOptions}
            value={filterValues['createdDate'] || ''}
            defaultValue={filterValues['createdDate'] || ''}
          />
          {filterValues.createdDate === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={filterValues['createdDate.customDates']}
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'createdDate.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Last Modified Date',
      key: 'lastModifiedDate',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'lastModifiedDate')
            }
            options={transactionDateOptions}
            value={filterValues['lastModifiedDate'] || ''}
            defaultValue={filterValues['lastModifiedDate'] || ''}
          />
          {filterValues.lastModifiedDate === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={filterValues['lastModifiedDate.customDates']}
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'lastModifiedDate.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Notes',
      key: 'notes',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            defaultValue={'Contains'}
            value={filterValues['notes.type'] || 'Contains'}
            onChange={(e) => handleFilterChange(e, 'select', 'notes.type')}
            options={[
              { key: 'Contains', value: 'Contains' },
              { key: 'Does not contain', value: 'Does not contain' },
            ]}
          />
          <Input
            value={filterValues['notes.value'] || ''}
            onChange={(e) =>
              handleFilterChange(e.target.value, 'text', 'notes.value')
            }
            style={{ flex: 1 }}
          />
        </div>
      ),
    },
  ];

  const handleReset = () => {
    setFilterValues(initFilters);
  };

  const handleFilterChange = (v, _type, key) => {
    setFilterValues({
      ...filterValues,
      [key]: v,
    });
  };

  const handleApplyFilter = () => {
    const month = filterValues['invoicePeriod.month']?.length || 0;
    const year = filterValues['invoicePeriod.year'] || '';
    if (month !== 0 && year === '') {
      message.error('Please select invoice period year to Apply filters');
    } else if (month === 0 && year !== '') {
      message.error('Please select invoice period month to Apply filters');
    } else {
      handleApply();
    }
  };

  return (
    <Drawer
      title={`Filters`}
      placement="right"
      size={400}
      onClose={() => setOpenFilters(false)}
      open={openFilters}
      extra={
        <Space>
          <Button onClick={() => handleReset()}>Reset</Button>
          <Button type="primary" onClick={() => handleApplyFilter()}>
            Apply
          </Button>
        </Space>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {filters.map((filter) => {
          return (
            <div key={filter.name} style={{ display: 'block' }}>
              <Text key={filter.name} style={{ fontSize: '16px' }}>
                {filter.name}
              </Text>
              {filter.type === 'text' ? (
                <Input
                  key={filter.name}
                  placeholder={filter.name}
                  defaultValue={filter.defaultValue}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) =>
                    handleFilterChange(e.target.value, 'text', filter.key)
                  }
                />
              ) : filter.type == 'select' ? (
                <CustomSelect
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  options={filter.options || []}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.name}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) => {
                    console.log(e), handleFilterChange(e, 'select', filter.key);
                  }}
                />
              ) : filter.type == 'custom' ? (
                filter.renderer()
              ) : null}
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
